var $0c053d6ef0255c08$exports = {};
$0c053d6ef0255c08$exports = {
    "collapse": `Recolher`,
    "columnResizer": `Redimensionamento de colunas`,
    "drag": `Arraste`,
    "expand": `Expandir`,
    "loading": `Carregando...`,
    "loadingMore": `Carregando mais...`,
    "resizeColumn": `Redimensionar coluna`,
    "sortAscending": `Ordenar por ordem crescente`,
    "sortDescending": `Ordenar por ordem decrescente`
};


export {$0c053d6ef0255c08$exports as default};
//# sourceMappingURL=pt-BR.module.js.map
